__turbopack_context__.v({
  "content": "ERQk8a_content",
  "imageWrapper": "ERQk8a_imageWrapper",
  "placeholder": "ERQk8a_placeholder",
});
